import React, { ChangeEvent } from "react";
import "./HeroText.scss";
import { updateTemplate } from "../../../../apis/updateTemplate";
import { toast } from "react-toastify";

export interface TextProps {
  note: string;
  setNote: React.Dispatch<React.SetStateAction<string>>;
  handleCloseTextModal: () => void;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const HeroTextEs: React.FC<TextProps> = ({
  note,
  setNote,
  handleCloseTextModal,
  loading,
  setLoading,
}) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newNote = event.target.value;
    setNote(newNote);
  };

  const onUpdateNote = () => {
    const update = {
      hero_section_body_es: note,
    };
    setLoading(true);
    updateTemplate(update)
      .then((response) => {
        toast.success("Nota actualizada con éxito");
        handleCloseTextModal();
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Nota Error de actualización. Inténtalo de nuevo.");
      });
  };

  return (
    <div className="edit-text">
      <input
        type="text"
        value={note}
        onChange={handleInputChange}
        className="edit-input"
      />
      <button className="edit-button" onClick={onUpdateNote}>
        {loading ? "Cargando..." : "Actualizar"}
      </button>
    </div>
  );
};

export default HeroTextEs;
